import { InfiniteProgress } from "@/components/shared/InfiniteProgress";
import { Box } from "@/components/ui/box";
import { Center } from "@/components/ui/center";
import { Text } from "@/components/ui/text";
import { usePayment } from "@/hooks/usePayment";
import { getValueFromStorage } from "@/utils/secureStore";
import { useFocusEffect } from "@react-navigation/native";
import { T } from "@transifex/react";
import { openURL } from "expo-linking";
import { router, useLocalSearchParams } from "expo-router";
import type { ParkPaymentIntentPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { useCallback } from "react";

export default function PurchasePaymentIntent() {
  const { noForm, rateID, rateName, termsAndConditionsOKTimestamp } = useLocalSearchParams<{
    noForm: string;
    rateID: string;
    rateName: string;
    termsAndConditionsOKTimestamp: string;
  }>();

  const { payment } = usePayment({ rateID, rateName, termsAndConditionsOKTimestamp });

  useFocusEffect(
    useCallback(() => {
      async function go(payment: ParkPaymentIntentPOSTSuccessResponse) {
        if (payment.requiresPayment && payment.stripeCheckoutLink) {
          await openURL(payment.stripeCheckoutLink);
        } else {
          const isPurchasingPass = await getValueFromStorage("isPurchasingPass");
          console.info("Not required to pay, going to the confirmation directly!");
          router.replace({
            pathname: "/purchase/confirmation",
            params: {
              isPurchasingPass,
              requiresPayment: "false",
              termsAndConditionsOKTimestamp,
              rateID,
            },
          });
        }
      }
      if (payment) {
        go(payment);
      }
    }, [payment, termsAndConditionsOKTimestamp, rateID]),
  );

  return (
    <Box className="flex-1">
      <Center className="flex-1 gap-[32px] pb-[52px] pt-[44px] px-[20px]">
        <Text className="font-bold text-lg text-typography-900 text-center">
          {noForm === "true" ? <T _str="Loading payment form..." /> : <T _str="Completing your purchase..." />}
        </Text>
        <InfiniteProgress className="w-3/4 max-w-xl" />
      </Center>
    </Box>
  );
}
